import { useQuery } from 'react-query';
import request from '../helpers/request';

const getWarrantyDocs = async (requestId) => {
  return await request.get(
    `/Warranty/docs/${requestId}`,
    {},
    'При загрузке документов произошла ошибка',
    []
  );
};

const useWarrantyDocs = (requestId, options = {}) =>
  useQuery([`warrantyDocs`, requestId], () => getWarrantyDocs(requestId), {
    placeholderData: [],
    enabled: !!requestId,
    ...options
  });

export default useWarrantyDocs;
